<template>
<div class="share-page" @click.stop="closeShare">
    <p class="share-line">
        <img src="./img/line.png" />
    </p>
    <p>一、点击“ ... ”</p>
    <p>
        二、点击“
        <img src="./img/share.jpg" /> ”分享至朋友圈
    </p>
    <p style="padding-left: 36px;">
        点击“
        <img src="./img/send.jpg" /> ”发给朋友
    </p>
    <!-- <div class="btn_close" @click="closeShareVideo"><van-icon name="close" /></div> -->
</div>
</template>

<script>
export default {
    name: "sharePage",
    methods: {
        closeShare() {
            this.$emit("closeSharePage", false);
        },
    },
};
</script>

<style lang="less">
.share-page {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10000 !important;
    font-size: 36px;
    font-weight: bold;
    color: #fff;
    line-height: 50px;
    padding: 50px;
    background: rgba(0, 0, 0, 0.6);

    .share-line {
        text-align: right;
        height: 150px;

        img {
            width: 270px;
            height: 150px;
            display: block;
            float: right;
        }
    }

    p {
        img {
            width: 36px;
            height: 36px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/sharePage/index.vue